// src/pages/Stocks/components/StockCard/StockCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrency } from '../../../../context/CurrencyContext';
import './StockCard.css';

const StockCard = ({ stock, onStockClick, customAction }) => {
  const navigate = useNavigate();
  const { formatCurrency } = useCurrency();

  const handleClick = () => {
    if (customAction) {
      customAction(stock);
    } else if (onStockClick) {
      onStockClick(stock);
    } else {
      // Default behavior - navigate to stock detail
      navigate(`/stocks/${stock.symbol}`);
    }
  };

  const formatChange = (change) => {
    const changeValue = parseFloat(change);
    const isPositive = changeValue >= 0;
    const symbol = isPositive ? '+' : '';
    
    return (
      <span className={`change ${isPositive ? 'positive' : 'negative'}`}>
        {symbol}{change}%
      </span>
    );
  };

  const getListingStageText = () => {
    // Always use custom labels, ignore backend listing_stage_display
    switch (stock.listing_stage) {
      case 'PRIVATE_EQUITY':
        return 'Private Equity';
      case 'PRE_IPO':
        return 'SCALE-UP ASSETS';
      case 'LISTED':
        return 'Listed';
      case 'FPO':
        return 'GROWTH ROUNDS ASSETS';
      default:
        // Fallback to backend display if stage is unknown
        return stock.listing_stage_display || 'Unknown';
    }
  };

  // FIXED: Proper price display logic
  const displayPrice = () => {
    // 1. First priority: Use backend's formatted display price
    if (stock.current_price_display) {
      return stock.current_price_display;
    }
    
    // 2. Second priority: Format the current_price locally
    if (stock.current_price) {
      return formatCurrency(parseFloat(stock.current_price));
    }
    
    // 3. Fallback
    return formatCurrency(0);
  };

  return (
    <div className="stock-card" onClick={handleClick}>
      <div className="stock-card-left">
        <div className="stock-image-container">
          {stock.image ? (
            <img 
              src={stock.image} 
              alt={stock.name}
              className="stock-image"
            />
          ) : (
            <div className="stock-image-placeholder">
              {stock.symbol.charAt(0)}
            </div>
          )}
        </div>
        
        <div className="stock-info">
          <div className="stock-symbol">{stock.symbol}</div>
          <div className="stock-name">{stock.name}</div>
          <div className="stock-listing-stage">
            {getListingStageText()}
          </div>
        </div>
      </div>
      
      <div className="stock-card-right">
        <div className="stock-price">{displayPrice()}</div>
        <div className="stock-change">
          {formatChange(stock.price_change || stock.price_change_percentage || 0)}
        </div>
      </div>
    </div>
  );
};

export default StockCard;